import BillTip from './BillTip'

import {
  Container,
  Title,
  SubTitle,
  LabelRow
} from './styles'

export default function BillTipList ({
  bill,
  billTips = [],
  professionals = [],
  enableEditting = true,
  hasEditPermission = true,
  hasDeletePermission = true,
  onEdit: handleEdit,
  onDelete: handleDelete
}) {
  return billTips.length > 0 && (
    <Container>
      <Title>Caixinhas</Title>
      <LabelRow>
        <SubTitle>Profissional</SubTitle>
        <SubTitle>Descrição</SubTitle>
        <SubTitle>Valor</SubTitle>
        <SubTitle>Comissão</SubTitle>
        <SubTitle>Ações</SubTitle>
      </LabelRow>
      {billTips.map ((tip, index) => (
        <BillTip
          key={index}
          bill={bill}
          data={tip}
          professionals={professionals}
          enableEditting={enableEditting}
          hasEditPermission={hasEditPermission}
          hasDeletePermission={hasDeletePermission}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      ))}
    </Container>
  )
}
